module.exports = __webpack_public_path__ + "img/tick.0dfe9c90.svg";